import type { FC } from 'react';

type ParaProps = {
	children: React.ReactNode;
	className?: string;
};

export const Para: FC<ParaProps> = ({ children, className }) => {
	return <p className={`skin-text ${className ?? ''}`}>{children}</p>;
};
